import { createFileRoute } from '@tanstack/react-router';

import { CataloguePage } from '@/features/catalogue/catalogue-page';
import { catalogueSearchSchema } from '@/features/catalogue/search-params';

export const Route = createFileRoute('/auctions/')({
	// Параметри пошуку валідуються схемою на межі маршруту, а не в компоненті.
	validateSearch: catalogueSearchSchema,
	component: CataloguePage,
});
